// src/i18n/store.ts
import { createStore } from "zustand/vanilla";

// src/i18n/translations/libui.json
var libui_default = {
  days: {
    friday: {
      en: "Friday",
      fr: "Vendredi"
    },
    monday: {
      en: "Monday",
      fr: "Lundi"
    },
    saturday: {
      en: "Saturday",
      fr: "Samedi"
    },
    sunday: {
      en: "Sunday",
      fr: "Dimanche"
    },
    thursday: {
      en: "Thursday",
      fr: "Jeudi"
    },
    tuesday: {
      en: "Tuesday",
      fr: "Mardi"
    },
    wednesday: {
      en: "Wednesday",
      fr: "Mercredi"
    }
  },
  form: {
    append: {
      en: "Append",
      fr: "Ajouter"
    },
    radioLabels: {
      false: {
        en: "False",
        fr: "Faux"
      },
      true: {
        en: "True",
        fr: "Vrai"
      }
    },
    remove: {
      en: "Remove",
      fr: "Supprimer"
    },
    required: {
      en: "This field is required",
      fr: "Ce champ est obligatoire"
    },
    reset: {
      en: "Reset",
      fr: "R\xE9initialiser"
    },
    submit: {
      en: "Submit",
      fr: "Soumettre"
    }
  },
  months: {
    april: {
      en: "April",
      fr: "Avril"
    },
    august: {
      en: "August",
      fr: "Ao\xFBt"
    },
    december: {
      en: "December",
      fr: "D\xE9cembre"
    },
    february: {
      en: "February",
      fr: "F\xE9vrier"
    },
    january: {
      en: "January",
      fr: "Janvier"
    },
    july: {
      en: "July",
      fr: "Juillet"
    },
    june: {
      en: "June",
      fr: "Juin"
    },
    march: {
      en: "March",
      fr: "Mars"
    },
    may: {
      en: "May",
      fr: "Mai"
    },
    november: {
      en: "November",
      fr: "Novembre"
    },
    october: {
      en: "October",
      fr: "Octobre"
    },
    september: {
      en: "September",
      fr: "Septembre"
    }
  },
  notifications: {
    types: {
      error: {
        en: "Error",
        fr: "Erreur"
      },
      info: {
        en: "Info",
        fr: "Attention"
      },
      success: {
        en: "Success",
        fr: "Succ\xE8s"
      },
      warning: {
        en: "Warning",
        fr: "Avertissement"
      }
    }
  },
  pagination: {
    info: {
      en: "Showing {{first}} to {{last}} of {{total}} results",
      fr: "Affichage de {{first}} \xE0 {{last}} sur {{total}} r\xE9sultats"
    },
    next: {
      en: "Next",
      fr: "Suivant"
    },
    previous: {
      en: "Previous",
      fr: "Pr\xE9c\xE9dent"
    }
  },
  searchBar: {
    placeholder: {
      en: "Search...",
      fr: "Rechercher..."
    }
  }
};

// src/i18n/internal.ts
import { format } from "@douglasneuroinformatics/libjs";
import { get } from "lodash-es";
function getTranslation(target, state, ...args) {
  let value;
  if (typeof target === "string") {
    value = get(state.translations, target);
  } else {
    value = target;
  }
  return format(value[state.resolvedLanguage] ?? value[state.fallbackLanguage], ...args);
}

// src/i18n/store.ts
var translationStore = createStore((set) => ({
  changeLanguage(language) {
    set({ resolvedLanguage: language });
  },
  fallbackLanguage: "en",
  isInitialized: false,
  resolvedLanguage: "en",
  translations: { libui: libui_default }
}));
var i18n = {
  init: ({ defaultLanguage, fallbackLanguage, translations } = {}) => {
    const state = translationStore.getState();
    if (state.isInitialized) {
      console.error("Cannot reinitialize translations store");
      return;
    }
    translationStore.setState({
      fallbackLanguage: fallbackLanguage ?? state.fallbackLanguage,
      isInitialized: true,
      resolvedLanguage: defaultLanguage ?? state.resolvedLanguage,
      translations: {
        ...state.translations,
        ...translations
      }
    });
  },
  t: (target, ...args) => {
    const state = translationStore.getState();
    return getTranslation(target, state, ...args);
  }
};

export {
  getTranslation,
  translationStore,
  i18n
};
//# sourceMappingURL=chunk-53GZFQK3.js.map